import { defineMessages } from 'react-intl';

export default defineMessages({
  counter: {
    id: 'kioskHome.counter',
    defaultMessage: `{count} {count, plural,
        one {experience}
        other {experiences}
    }`,
  },
});
